import { USER_STATE_IN_ORGANIZATION } from '../api/organization';

export function getUserProfilePictureUrl(imagePath: string | null): string | null {
  if (!imagePath) {
    return null;
  }
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  return `${import.meta.env.VITE_API_BASE_ENDPOINT}/${imagePath}`;
}

export function getUserInitials(fullName: string): string {
  if (!fullName) {
    return 'N/A';
  }

  const names = fullName.split(' ');
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
}

export function getLabelForUserStateInOrganization(status: USER_STATE_IN_ORGANIZATION): string {
  switch (status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'Deactivated';
    case 'INVITED':
      return 'Pending';
    default:
      return 'Unknown';
  }
}

export const INVITATION_EXPIRY = 604800000; //1 week in ms

export const getPlanningSessionKey = (spaceId: number, sessionId: number) => {
  return `${spaceId}-${sessionId}`;
};
